import type { ReactNode } from 'react'
import { m } from '~/paraglide/messages'
import { isPremium } from '~/params'
import { GradientBorderBox } from './gradient-border'
import { AllowlistIocn } from './icons/allowlist'
import { AnalysisIcon } from './icons/analysis'
import { BlockMoreAppsIcon } from './icons/block-more-apps'
import { ExclusiveTreesIcon } from './icons/exclusive-trees'
import { ExtraRealTreeIcon } from './icons/extra-real-tree'
import { NoAdsIcon } from './icons/no-ads-icon'
import { SeasonalTreeIcon } from './icons/seasonal-tree-icon'
import { TripleCoinsIcon } from './icons/triple-coins-icon'
import { LearnMoreButton } from './learn-more-button'

export function FeatureList() {
  const features = isPremium
    ? [
        { Icon: TripleCoinsIcon, text: m.triple_coin_reward() },
        { Icon: ExclusiveTreesIcon, text: m.plus_exclusive_tree() },
        { Icon: SeasonalTreeIcon, text: m.seasonal_crystal_trees() },
        { Icon: BlockMoreAppsIcon, text: m.app_block() },
      ]
    : [
        { Icon: TripleCoinsIcon, text: m.triple_coin_reward() },
        { Icon: AllowlistIocn, text: m.custom_app_allow_list() },
        { Icon: ExclusiveTreesIcon, text: m.free_use_crystal_tree() },
        { Icon: AnalysisIcon, text: m.focus_trend_analysis() },
        { Icon: ExtraRealTreeIcon, text: m.plant_tree_for_earth() },
        { Icon: NoAdsIcon, text: m.no_ads() },
      ]

  return (
    <GradientBorderBox
      radius={32}
      borderWidth={2}
      gradient="linear-gradient(to bottom, #2382FF1A 0%, #2382FF00 60%)"
      className="w-full rounded-[32px] bg-[#2382FF1A]"
    >
      <div className="flex flex-col gap-6 p-6">
        {/* Feature list */}
        <div className="flex flex-col gap-4">
          {features.map((feature, index) => (
            <FeatureListItem
              key={index}
              Icon={feature.Icon}
              text={feature.text}
            />
          ))}
        </div>

        {/* Learn more button */}
        <div className="flex w-full items-center justify-center">
          <LearnMoreButton />
        </div>
      </div>
    </GradientBorderBox>
  )
}

type FeatureListItemProps = {
  Icon: () => ReactNode
  text: string
}

function FeatureListItem({ Icon, text }: FeatureListItemProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="shrink-0">
        <Icon />
      </div>
      <p className="text-sm leading-5 text-white">{text}</p>
    </div>
  )
}
